export default "__VITE_ASSET__CGqxYdKM__"